import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Question, Option } from '../../../../../classes';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService, ReplyService } from '../../../../../services';

@Component({
  template: ''
})
export class QuestionComponent implements OnInit {
  @Input() question: Question;
  @Input() questionsFormGroup: FormGroup;
  as: string;
  questionId: string;
  questionFormGroup: FormGroup;
  constructor(
    protected reply: ReplyService,
    protected auth: AuthService,
    protected cdRef: ChangeDetectorRef
  ) {
    this.as = this.auth.as;
  }

  subscriptions: Subscription[] = [];
  required: FormControl;
  ngOnInit() {
    this.addControllers();
    this.subscriptions.push(
      this.reply.tracker
        .getChildTracker([this.as, this.question.id])
        .onContentUpdate.subscribe(() => {
          this.required.setValue(
            this.question.options.filter(o =>
              this.reply.isChecked(o, ['static', 'reserved', 'confirmed'], this.as)
            ).length
          );
          this.refreshView();
        })
    );
    this.subscriptions.push(
      this.question.onContentUpdate.subscribe(() => this.refreshView())
    );
  }
  addControllers() {
    this.questionId = this.question.id;
    this.questionFormGroup = new FormGroup({ options: new FormGroup({}) });
    this.required = new FormControl(0, [
      Validators.min(this.question.min_checked_option_cnt),
      Validators.max(this.question.max_checked_option_cnt)
    ]);
    this.questionFormGroup.setControl('required', this.required);
    if (this.questionsFormGroup)
      this.questionsFormGroup.setControl(
        this.question.id,
        this.questionFormGroup
      );
  }
  removeControllers() {
    if (this.questionsFormGroup)
      this.questionsFormGroup.removeControl(this.questionId);
  }
  ngOnDestroy() {
    this.removeControllers();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  refreshView() {
    this.cdRef.detectChanges();
  }
  TrackByFn(index: number, option: Option) {
    return option.id;
  }
}
